// eslint-disable-next-line import/prefer-default-export
export const CLASS_TYPE_MAP = {
  1: 'Tất cả',
  2: 'tutor',
  3: 'duo',
};
// eslint-disable-next-line import/prefer-default-export
export const headerStudyResultDuo = [
  {
    text: 'Ngày diễn ra',
    align: 'left',
  },
  {
    text: 'Buổi học',
    align: 'left',
  },
  {
    text: 'Môn',
    align: 'left',
  },
  {
    text: 'Điểm danh',
    align: 'center',
  },
  {
    text: 'BTVN',
    align: 'left',
  },
  {
    text: 'BT tương tác',
    align: 'center',
  },
  {
    text: 'Xếp hạng',
    align: 'center',
  },
];
export const headerStudyResultSelf = ['Buổi học', 'Môn', 'Video', 'Tài liệu', 'BT về nhà'];
export const MAP_NOTIFICATION = {
  1: {
    text: 'Thông báo',
    color: '#6C9200',
  },
  2: {
    text: 'Nhắc nhở',
    color: '#6C9200',
  },
};

export const CLASS_STATUS_PRIORITY = [
  'đang học - tutor',
  'đang diễn ra - duo',
  'chờ khai giảng - tutor',
  'chờ xếp lớp - tutor',
  'lớp nháp - tutor',
  'xếp lớp sau - tutor',
  'chờ chuyển lớp - tutor',
  'chuyển phí - tutor',
  'bảo lưu - tutor',
  'đã kết thúc - tutor',
  'chờ khai giảng - duo',
  'tạm dừng - duo',
  'tạm nghỉ - duo',
  'hết buổi - tutor',
  'hoàn thành - duo',
  'đã kết thúc - duo',
];
export const tabViewDuoBlendedCare = [
  { title: 'Duo Live', icon: '', disable: false },
  { title: 'Tự học', icon: '', disable: false },
];
export const HIGHLIGHT_TYPE = {
  STUDENT_OFF_TICKET: 1, // nghi phep
  TEST_SCHEDULE: 2, // lich kiem tra
  TEST_RESULT: 3, // ket qua kiem tra
  RESERVE: 4, // bao luu
  RESERVE_RETURN: 5, // di hoc lai
  TUTOR_STUDY_LATE: 6, // tutor vào muộn
  TUTOR_STUDY_NOT_JOIN: 7, // tutor nghỉ ko phép
  TUTOR_STUDY_EARLY_LEAVE: 8, // tutor ra khỏi lớp sớm
  DUO_STUDY_LATE: 9,
  DUO_STUDY_NOT_JOIN: 10,
  DUO_STUDY_EARLY_LEAVE: 11,
};
export const FILTER_SUBJECT_TYPE = {
  ALL: 1,
  TUTOR: 2,
  DUO: 3,
};
export const DUO_CLASS_TYPE = {
  DUO_CLASS: 0,
  SELF_STUDY: 1,
};
